module.exports = new __parcel__URL__("platinum2.23d2ea8c.png").toString();